import {
    PieChartOutlined,
    SettingOutlined,
    BankOutlined,
    HomeOutlined,
    ApiOutlined,
    UserOutlined,
    TransactionOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const items = [
    {
        label: (
            <Link to="/invoices">
                <PieChartOutlined /> Нэхэмжлэл
            </Link>
        ),
        key: "invoices",
    },
    {
        label: (
            <Link to="/users">
                <UserOutlined /> Хэрэглэгч
            </Link>
        ),
        key: "users",
    },
    {
        label: (
            <Link to="/bank-transactions">
                <TransactionOutlined /> Банкны хуулга
            </Link>
        ),
        key: "bank-transactions",
    },
    {
        label: (
            <span>
                <SettingOutlined /> Тохиргоо
            </span>
        ),
        key: "settings",
        children: [
            {
                label: (
                    <Link to="/settings/merchant">
                        <HomeOutlined /> Байгууллага
                    </Link>
                ),
                key: "settings-merchant",
            },
            {
                label: (
                    <Link to="/settings/api">
                        <ApiOutlined /> API
                    </Link>
                ),
                key: "settings-api",
            },
            {
                label: (
                    <Link to="/settings/payment-processors">
                        <BankOutlined /> Төлбөрийн сонголтууд
                    </Link>
                ),
                key: "settings-payment-processors",
            },
        ],
    },
];

export default items;
